import { render } from "./EmployeeTrackerLogs.vue?vue&type=template&id=f225ba5e&scoped=true"
import script from "./EmployeeTrackerLogs.vue?vue&type=script&lang=js"
export * from "./EmployeeTrackerLogs.vue?vue&type=script&lang=js"

import "./employee-tracker-log.scss?vue&type=style&index=0&id=f225ba5e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f225ba5e"]])

export default __exports__